import React from 'react';

export default class WhiteListRedirect extends React.Component {
  componentDidMount() {
    window.location = 'https://whitelist.skycoin.com';
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Whitelist/WhiteListRedirect.js